// BRIEF 86 PHASE 2, STEP 2 (run by brief 90 §5) — the Emails wrapper, once:
// a header, and the pane under it. 44 lines in `CaseView` and 46 in
// `CollectiveCaseView`, 82% normalised.
//
// ── 194 B.1b — THE PARTY LIST IS SERVED, SO THIS ASSEMBLES NOTHING NOW ──────
// Until 194 this wrapper assembled the party list the e-mail search matched
// against from five id lists the host normalised (86a, RULED 2026-08-17:
// clientLinks is a storage-shape discriminator, not a second committee) and
// five directories. The search's party list is served now — every party
// address with its name and role, from the nine junctions the server already
// walks (`GET …/emails/parties`) — and the e-mail pane fetches it itself, so
// the id lists, the directories and the assembly left this file with 194.
//
// `className` is `csSec-emails` in CV and `csSec-emailBody` in CCV, and they are
// NOT interchangeable: two different `grid-area`s in two different grids. It
// is host layout, so it is a prop — like `style`, and for the same reason.
//
// `openLogTime` is passed by BOTH hosts since 184 C.2 (ruled (iii)): the
// drawer's "+ Add time entry on selected" opens the time modal on a case AND on
// a collective case, prefilled by `lib/emailLogTimePrefill.ts` with `caId` or
// `ccId` by the kind.
//
// ── 194 B.0 — THE SECTION IS "COMMUNICATION", AND IT HOLDS TWO PANES ────────
// Laurent, 2026-09-18: the section that was "E-mails" holds WhatsApp too, so
// it is named for what it holds; inside it the first pane is titled E-mails
// and the second Messages. The WhatsApp card (108 §4) was mounted by each host
// beside this pane in its own grid slot; it is mounted HERE now, under the one
// header, so the two panes collapse together and the hosts hold one mount.
/* `import React` is here for `react/react-in-jsx-scope`, which the committed
   eslint config still enforces and the ratchet counts once per JSX element
   (166's remedy, CaseEmailsSection.tsx:1): 194 B.0 adds two elements to this
   file, and putting React in scope is the rule's own cure — it clears the
   same debt for every element already here. */
import React from "react";
import { SectionHeader } from "./SharedUI";
import CaseEmailsSection from "./CaseEmailsSection";
import WhatsappImportPane from "./WhatsappImportPane";

export default function CaseEmailsPane({
  kind, // 'case' | 'cc'
  cs,
  currentUser,
  co,
  toast,
  openLogTime,
  firmSettings = null,
  sCol,
  tog,
  t,
  className,
  style,
}: {
  kind: "case" | "cc";
  cs: { id: number };
  currentUser?: number | null;
  co: unknown[];
  toast: (m: string) => void;
  openLogTime?: (prefill: Record<string, unknown>) => void;
  /** 198 §C — the firm settings object, `periodBounds`' axis input for both
   *  panes' period pickers (D.3) */
  firmSettings?: unknown;
  sCol: (k: string) => boolean;
  tog: (k: string) => void;
  t: (k: string, o?: Record<string, unknown>) => string;
  className: string;
  style?: Record<string, unknown>;
}) {
  return (
    <div className={className} style={style} data-secollapsed={sCol("emails") ? "1" : "0"}>
      <SectionHeader
        title={t("communication.title", { fallback: "Communication" })}
        collapsible
        open={!sCol("emails")}
        onToggle={() => tog("emails")}
      />
      {/* 194 B.0 — the two panes, one column: each card carries its own pane
          title (E-mails · Messages). One direct child, so the section's
          collapse (`[data-secollapsed]`'s rule) hides both at once. */}
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        <CaseEmailsSection
          cs={cs}
          currentUser={currentUser}
          co={co}
          kind={kind}
          toast={toast}
          openLogTime={openLogTime}
          firmSettings={firmSettings}
        />
        <WhatsappImportPane kind={kind} cs={cs} toast={toast} firmSettings={firmSettings} />
      </div>
    </div>
  );
}
